import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes, { func } from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {  isEmpty, map, size } from "lodash";
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import { getClientDetail,addClientSellerOphouse, getClientSellerListing, getClientSellerOphouse, deleteClientopenhouse, updateClientOpenhouse, updateClientOpenhouseFeedback } from "../../store/clients/actions"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import { azureConfig } from "helpers/azureConfig";
import qrCodeImg from "../../assets/img/qr-code.jpg"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap"
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import SaveButton from "components/buttons/save";
import ClientSellerMenu from "./menu/client-seller-menu";
import ClientSellerBreadcrumbs from "components/Common/ClientSellerBreadcrumbClient";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import NoAccess from "components/NoAccess";
import JoditEditor from "jodit-react";
import ActionEditLink from "components/buttons/actionEditlink";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import ActionFeedback from "components/buttons/actionFeedback";
import TimePicker from "components/dropdowns/Timepicker";
import { UPLOADTEXT } from "constants/layout";
import SafeField from "helpers/SafeField";
class ClientSellerOpen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ophouse :'',
      expandedRow: null,
    }
    
    this.handleSellerOphouseSubmit = this.handleSellerOphouseSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleSend = this.toggleSend.bind(this);
  }
  async handleFileChange(event, setFieldValue) {
       const file = event.currentTarget.files[0];
       if (file) {
         const maxSize = 5 * 1024 * 1024;
         const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
         const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png'];
         const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
         if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
           Swal.fire({
             title: 'File type or extension not allowed',
             text: 'Please upload a PDF, DOC, JPG, or PNG file.',
             icon: 'warning',
             confirmButtonText: 'OK',
           });
           //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
           return;
         }
         if (file.size > maxSize) {
           Swal.fire({
             title: 'Size not allowed',
             text: 'Please Upload Maximum 5MB File',
             icon: 'warning',
             confirmButtonText: 'OK',
           });
          
         }
         this.setState({ btnloading: true });
         const sasToken = azureConfig.sasToken;
         const containerName = azureConfig.containerName;
         const storageAccountName = azureConfig.storageAccountName;
         const fileName = `${Date.now()}_${file.name}`;
         const blobServiceClient = new BlobServiceClient(
           `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
         );
         const containerClient = blobServiceClient.getContainerClient(containerName);
         const blobClient = containerClient.getBlockBlobClient(fileName);
   
         try {
           await blobClient.uploadBrowserData(file, {
             blobHTTPHeaders: { blobContentType: file.type }
           });
   
        
           if (setFieldValue) {
             const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
             setFieldValue(`brochureLink`, fileUrl);
             setFieldValue(`brochureContent`, fileUrl);
             this.setState({ fileUploaded: true });
           }
         } catch (error) {
           console.error('Error uploading file:', error);
   
         }
       }
     }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (ophouse) => {
    this.setState({ ophouse: ophouse });
    this.setState({ deleteModal: true });
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  handleDeleteOpenhouse = () => {
    const { onDeleteOpenhouse } = this.props;
    const { ophouse } = this.state;
    
    if (ophouse.id !== undefined) {
      onDeleteOpenhouse(ophouse);
      this.setState({ deleteModal: false });
    }
  };

  handleSellerOphouseSubmit(value){
    //
    this.props.addClientSellerOphouse(value, this.props.history);
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientSellerListing, onGetClientSellerOphouse } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientSellerListing(params.id);
    onGetClientSellerOphouse(params.id);
}
componentDidUpdate(prevProps, prevState, snapshot) {
  const { ophouses } = this.props;
  if (!isEmpty(ophouses) && size(prevProps.ophouses) !== size(ophouses)) {
    this.setState({ ophouses: {}, isEdit: false });
  }
}
toggleRightCanvas() {
  this.setState({ ophouse: "", isEdit: false, isRight: !this.state.isRight });
  this.toggle();
}
toggleRightCanvas = arg => {
  const ophouse = arg;

  this.setState({
    ophouse: {
  
      id:ophouse.id,
      clientSellerOpenhouseId: ophouse.clientSellerOpenhouseId,
      clientId:ophouse.clientId,
      agentId: ophouse.agentId,
      clientListingId: ophouse.clientListingId,
      openhouseDate: ophouse.openhouseDate,
      startTime: ophouse.startTime,
      endTime: ophouse.endTime,
      agentName: ophouse.agentName,
      agentOrganization: ophouse.agentOrganization,
      agentContact: ophouse.agentContact,
      agentEmail: ophouse.agentEmail,
      openhouseUrl: ophouse.openhouseUrl,
      brochureLink: ophouse.brochureLink,
      brochureContent:ophouse.brochureContent,
      brochureStorageType:ophouse.brochureStorageType,
      isActive:ophouse.isActive
     
    },
    isEdit: true,
  });
  this.toggle();
};
sendtoggle() {
  this.setState(prevState => ({
    isSend: !prevState.isSend
  }));
}
toggleSend(){
  this.setState({ ophouse: "", isEdit: false, isSend: !this.state.isSend });
  this.sendtoggle();
} 
toggleSend = arg => {
  const ophouse = arg;
  this.setState({
    ophouse: {
      id:ophouse.id,
      clientSellerOpenhouseId: ophouse.clientSellerOpenhouseId,
      clientId:ophouse.clientId,
      agentId: ophouse.agentId,
      noOfVisitors:ophouse.noOfVisitors,
      noOfInquires:ophouse.noOfInquires,
      feedbackToClient:ophouse.feedbackToClient,
      reactionPropertyFeatures:ophouse.reactionPropertyFeatures,
      reactionWhatnotLiked:ophouse.reactionWhatnotLiked,
      commentsOnPricing:ophouse.commentsOnPricing,
      suggestionActionalbleInsights:ophouse.suggestionActionalbleInsights,
      marketPositioning:ophouse.marketPositioning    
    },
    isEdit: true,
  });
  this.sendtoggle();
};
 toggleExpand = (index) => {
    this.setState({ expandedRow: this.state.expandedRow === index ? null : index });
  };
  render() {
    const { listings, ophouses, clietDetail, onUpdateSellerOpenhouse, onUpdateClientOpenhouseFeedback, isResponsive } = this.props;
    const now = new Date();
    now.setMinutes(now.getMinutes() + 30);
    const edTime = new Date(now);
    const ophouse = this.state.ophouse;
    const { isEdit, deleteModal, expandedRow } = this.state;
    const hasSellerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 2);
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteOpenhouse}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
       <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
          {hasSellerType ? (
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <ClientSellerBreadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t( "Open House")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
            <ClientSellerMenu isResponsive={isResponsive} />
            <Row>
              {/* <Col xl="3">
              <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}

              <Col xl="12">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    clientListingId: (this.state && this.state.clientListingId) || "",
                    //clientListingId: 1,
                    openhouseDate: new Date(),
                    startTime: new Date(),
                    endTime: edTime,
                    agentName:"Sudhir",
                    agentOrganization:"Esimplified",
                    agentContact:"965007540",
                    agentEmail:"sudhirsingh.info@gmail.com",
                    openhouseUrl:'',
                    agentId: localStorage.getItem('userId'),
                    clientId:this.props.match.params.id,
                    brochureLink: this.state.fname,
                    brochureContent: this.state.selectedImage,
                    brochureStorageType: 0,


                  }}
                  validationSchema={Yup.object().shape({
                    clientListingId: Yup.string().required("This is Required"),
                    openhouseDate : Yup.date().required('This is Required'),
                    startTime : Yup.string().required("This is Required"),
                    endTime :Yup.string().required("This is Required"),


                  })}

                  onSubmit={this.handleSellerOphouseSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Card className="border-full">
                        <CardBody>
                          <h5 className="card-title">Add New Open House</h5>

                          <Row>
                          <Col sm="12">
                      <div className="btn-group" role="group">
                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="brochureStorageType"
                          id="brochureStorageType1"
                          autoComplete="off"
                          value={0}
                          onChange={() => setFieldValue("brochureStorageType", 0)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="brochureStorageType1"
                        >
                          Upload Brochure
                        </label>

                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="brochureStorageType"
                          id="brochureStorageType2"
                          autoComplete="off"
                          value={1}
                          onChange={() => setFieldValue("brochureStorageType", 1)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="brochureStorageType2"
                        >
                          Add Link
                        </label>
                      </div>
                    </Col>
                    <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="clientListingId">
                                  {this.props.t("Listing*")}
                                </Label>
                                <SafeField as="select" name="clientListingId" className={
                                  "form-control" +
                                  (errors.clientListingId && touched.clientListingId
                                    ? " is-invalid"
                                    : "")
                                } onChange={handleChange}>
                                  <option value="">Select</option>
                                  {map(listings, (listing, listingskey) => (
                                     <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                  ))} 
                                </SafeField>
                                <ErrorMessage
                                  name="clientListingId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                    <Col sm="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="openhouseDate">
                                  {this.props.t("Date*")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.openhouseDate && touched.openhouseDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                   
                                    onChange={(value) => setFieldValue('openhouseDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d",
                                      minDate:'today'
                                    }}
                                  />
                                </InputGroup>
                              </FormGroup>

                            </Col>
                            <Col sm="2">
                             <TimePicker
                              name="startTime"
                              label="Start Time *"
                              value={values.startTime}
                              onChange={(val) => setFieldValue("startTime", val)}
                              onBlur={() => setFieldTouched("startTime", true)}
                              minTime={null}
                              error={errors.startTime}
                              touched={touched.startTime}
                            />
                            
                            </Col>

                            <Col sm="2">
                              <TimePicker
                              name="endTime"
                              label="End Time *"
                              value={values.endTime}
                              onChange={(val) => setFieldValue("endTime", val)}
                              onBlur={() => setFieldTouched("endTime", true)}
                              minTime={values.startTime}
                              disabled={!values.startTime}
                              error={errors.endTime}
                              touched={touched.endTime}
                            />
                                                         
                            
                            </Col>
                            <Col sm="3">
                            {values.brochureStorageType === 0 && (
                                <div className="form-group mb-3">
                              <Label htmlFor="file">Brochure File</Label>
                               <input
                                    type="file"
                                    className="form-control"
                                    onChange={event => this.handleFileChange(event, setFieldValue)}
                                  />

                                   <small className="text-muted font-size-12">
                                    {UPLOADTEXT.DFOR}
                                  </small>
                              </div>
                             )}
                               {values.brochureStorageType === 1 && (
                             <FormGroup className="mb-3">
                            <Label htmlFor="documentLink">{this.props.t("Link")}</Label>
                            <SafeField
                              name="documentLink"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.documentLink && touched.documentLink
                                  ? " is-invalid"
                                  : "")
                              }
                              id="documentLink"
                            />
                          </FormGroup>
                           )}
                            </Col>
                           

                           
                          </Row>


                          <div className="clearfix">
                            <SaveButton>Save</SaveButton>
                            </div>

                        </CardBody>
                      </Card>
                    </Form>
                  )}
                </Formik>

                <Row>
                  <Col sm="12">
                    <Card className="border-full mt-4">
                      <CardBody>
                        <h5 className="card-title">All Open house(s)</h5>
                        <div className="table-responsive">
                           <table className="table table-striped">
        <thead>
          {isResponsive ? (
            <tr>
              <th>Listing</th>
              <th>Date</th>
              <th>Time</th>
              <th></th>
            </tr>
          ) : (
            <tr>
               <th>#</th>
              <th>Listing</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Brochure</th>
              <th>QR Code</th>
              <th>URL</th>
              <th>#Visitors</th>
              <th>Visitors</th>
              <th>Feedback</th>
              <th>Action</th>
            </tr>
          )}
        </thead>

        <tbody>
          {map(ophouses, (ophouse, opkey) => (
            <React.Fragment key={opkey}>
              {/* Main Row */}
              <tr
                onClick={() => isResponsive && this.toggleExpand(opkey)}
                style={{ cursor: isResponsive ? "pointer" : "default" }}
              >
                {isResponsive ? (
                  <>
                    <td>{ophouse?.clientListing?.mlsId}</td>
                    <td><Moment format="Do MMM">{ophouse.openhouseDate}</Moment></td>
                    <td>{ophouse.startTime} - {ophouse.endTime}</td>
                    <td style={{ textAlign: "right" }}>
                      {expandedRow === opkey ? "▲" : "▼"}
                    </td>
                  </>
                ) : (
                  <>
                    <td>{opkey + 1}</td>
                    <td>{ophouse?.clientListing?.mlsId}</td>
                    <td><Moment format="Do MMMM YYYY">{ophouse.openhouseDate}</Moment></td>
                    <td>{ophouse.startTime}</td>
                    <td>{ophouse.endTime}</td>
                    <td><a target="_blank" className="btn-d" rel="noreferrer" href={ophouse.brochureUrl}><i className='bx bxs-cloud-download'></i></a></td>
                    <td><a target="_blank" rel="noreferrer" href={"https://pages.realtyspacehub.com/openhouse/" + ophouse.clientSellerOpenhouseId}><img src={qrCodeImg} style={{width:32}} /></a></td>
                    <td><a target="_blank" rel="noreferrer" href={"https://pages.realtyspacehub.com/openhouselead/" + ophouse.clientSellerOpenhouseId}>View</a></td>
                    <td>{ophouse.noOfInquires}</td>
                    <td><Link to={"/clients/open-list/" + ophouse.clientId + "/" + this.props.match.params.clientId + "/" + ophouse.id }>View</Link></td>
                    <td><Link onClick={() => this.toggleSend(ophouse)} to="#">Feedback</Link></td>
                    <td>
                      <ActionEdit onClick={() => this.toggleRightCanvas(ophouse)} /> <ActionDelete onClick={() => this.onClickDelete(ophouse)} /> 
                    </td>
                  </>
                )}
              </tr>

              {/* Expanded Row (Mobile) */}
              {isResponsive && expandedRow === opkey && (
                <tr>
                  <td colSpan={4} className="p-2">
                    <div><strong>Brochure:</strong> <a target="_blank" className="btn-d" rel="noreferrer" href={ophouse.brochureUrl}><i className='bx bxs-cloud-download'></i></a></div>
                    <div><strong>QR Code:</strong> <a target="_blank" rel="noreferrer" href={"https://pages.realtyspacehub.com/openhouse/" + ophouse.clientSellerOpenhouseId}><img src={qrCodeImg} style={{width:32}} /></a></div>
                    <div><strong>URL:</strong> <a target="_blank" rel="noreferrer" href={"https://pages.realtyspacehub.com/openhouselead/" + ophouse.clientSellerOpenhouseId}>View</a></div>
                    <div><strong>#Visitors:</strong> {ophouse.noOfInquires}</div>
                    <div><strong>Visitors:</strong> <Link to={"/clients/open-list/" + ophouse.clientId + "/" + this.props.match.params.clientId + "/" + ophouse.id }>View</Link></div>
                    <div><strong>Feedback:</strong> <Link onClick={() => this.toggleSend(ophouse)} to="#">Feedback</Link></div>
                    <div className="mt-2">
                      <ActionEdit onClick={() => this.toggleRightCanvas(ophouse)} /> <ActionDelete onClick={() => this.onClickDelete(ophouse)} /> 
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
                       
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

              </Col>

            </Row>
            </Col>
            </Row>
          ) : (
            <NoAccess />
          )}
            <Offcanvas
                      isOpen={this.state.isRight}
                      direction="end"
                      toggle={this.toggleRightCanvas}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvas}>
                        Update 
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:ophouse.id,
                    clientSellerOpenhouseId: ophouse.clientSellerOpenhouseId,
                    clientId:ophouse.clientId,
                    agentId: ophouse.agentId,
                    clientListingId: ophouse.clientListingId,
                    openhouseDate: ophouse.openhouseDate,
                    startTime: ophouse.startTime,
                    endTime: ophouse.endTime,
                    agentName: ophouse.agentName,
                    agentOrganization: ophouse.agentOrganization,
                    agentContact: ophouse.agentContact,
                    agentEmail: ophouse.agentEmail,
                    openhouseUrl: ophouse.openhouseUrl,
                    brochureLink: ophouse.brochureLink,
                    brochureContent:ophouse.brochureContent,
                    brochureStorageType:ophouse.brochureStorageType,
                    isActive:ophouse.isActive
                  }}
                  validationSchema={Yup.object().shape({
                    clientListingId: Yup.string().required("This is Required"),

                  })}

                  onSubmit={values => {
                    //
                    if (isEdit) {
                      const updateOpen = {
                        id:values.id,
                        clientSellerOpenhouseId: values.clientSellerOpenhouseId,
                        clientId:values.clientId,
                        agentId: values.agentId,
                        clientListingId: values.clientListingId,
                        openhouseDate: values.openhouseDate,
                        startTime: values.startTime,
                        endTime: values.endTime,
                        agentName: values.agentName,
                        agentOrganization: values.agentOrganization,
                        agentContact: values.agentContact,
                        agentEmail: values.agentEmail,
                        openhouseUrl: values.openhouseUrl,
                        brochureLink: values.brochureLink,
                        brochureContent:(this.state.selectedImage ? this.state.selectedImage : values.brochureContent),
                        brochureStorageType:values.brochureStorageType,
                        isActive:values.isActive
                      };

                      onUpdateSellerOpenhouse(updateOpen);
                    } else {
                      
                    }
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >
                      

                          <Row>
                            <Col sm="12">
                            <div className="form-group mb-3">
                          <Label htmlFor="file">Broucher File</Label>
                          <input id="file" name="file" type="file" onChange={this.onFileChange} className="form-control" />
                           <small className="text-muted font-size-12">
                                    {UPLOADTEXT.DFOR}
                                  </small>
                        </div>
                            </Col>
                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="clientListingId">
                                  {this.props.t("Listing")}
                                </Label>
                                <SafeField as="select" name="clientListingId" className={
                                  "form-control" +
                                  (errors.clientListingId && touched.clientListingId
                                    ? " is-invalid"
                                    : "")
                                } onChange={handleChange}>
                                  <option value="">Select</option>
                                  {map(listings, (listing, listingskey) => (
                                     <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                  ))} 
                                </SafeField>
                                <ErrorMessage
                                  name="clientListingId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            <Col sm="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="openhouseDate">
                                  {this.props.t("Date")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.openhouseDate && touched.openhouseDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.openhouseDate}
                                    onChange={(value) => setFieldValue('openhouseDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                </InputGroup>
                              </FormGroup>

                            </Col>
                            <Col sm="12">
                             <TimePicker
                              name="startTime"
                              label="Start Time *"
                              value={values.startTime}
                              onChange={(val) => setFieldValue("startTime", val)}
                              onBlur={() => setFieldTouched("startTime", true)}
                              minTime={null}
                              error={errors.startTime}
                              touched={touched.startTime}
                            />
                           
                            </Col>

                            <Col sm="12">
                             <TimePicker
                              name="endTime"
                              label="End Time *"
                              value={values.endTime}
                              onChange={(val) => setFieldValue("endTime", val)}
                              onBlur={() => setFieldTouched("endTime", true)}
                              minTime={values.startTime}
                              disabled={!values.startTime}
                              error={errors.endTime}
                              touched={touched.endTime}
                            />
                             
                            </Col>
                          </Row>


                          <div className="clearfix">
                          <UpdateButton>{this.props.t("Update")}</UpdateButton>{ " " } <RsLink onClick={closed}>Close</RsLink>
                            </div>

                        
                    </Form>
                  )}
                </Formik>     

                      </OffcanvasBody>
                    </Offcanvas>  


                     <Offcanvas
                      isOpen={this.state.isSend}
                      direction="end"
                      toggle={this.toggleSend}
                      style={{width:600}}
                    >
                      <OffcanvasHeader toggle={this.toggleSend}>
                        Openhouse Feedback
                      </OffcanvasHeader>
                      <OffcanvasBody className="open-feedback">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:ophouse.id,
                    clientSellerOpenhouseId: ophouse.clientSellerOpenhouseId,
                    clientId:ophouse.clientId,
                    agentId: ophouse.agentId,
                    noOfVisitors:ophouse.noOfInquires,
                    feedbackToClient:ophouse.feedbackToClient,
                    reactionPropertyFeatures:ophouse.reactionPropertyFeatures,
                    reactionWhatnotLiked:ophouse.reactionWhatnotLiked,
                    commentsOnPricing:ophouse.commentsOnPricing,
                    suggestionActionalbleInsights:ophouse.suggestionActionalbleInsights,
                    marketPositioning:ophouse.marketPositioning

                  }}
                  validationSchema={Yup.object().shape({
                    //feedbackToClient: Yup.string().required("This is Required")
                  })}

                  onSubmit={values => {
                    //
                    if (isEdit) {
                      const updateOpen = {
                        id:values.id,
                        clientSellerOpenhouseId: values.clientSellerOpenhouseId,
                        clientId:values.clientId,
                        agentId: values.agentId,
                        noOfVisitors:parseInt(values.noOfVisitors),
                        feedbackToClient: values.feedbackToClient,
                        reactionPropertyFeatures:values.reactionPropertyFeatures,
                        reactionWhatnotLiked:values.reactionWhatnotLiked,
                        commentsOnPricing:values.commentsOnPricing,
                        suggestionActionalbleInsights:values.suggestionActionalbleInsights,
                        marketPositioning:values.marketPositioning
                      };

                      onUpdateClientOpenhouseFeedback(updateOpen);
                    } else {
                      
                    }
                    this.sendtoggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                   <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="feedbackToClient">Number of visitors</Label>
                              <SafeField
                             type="text"
                              name="noOfVisitors"
                              className={
                                "form-control" +
                                (errors.noOfVisitors && touched.noOfVisitors
                                  ? " is-invalid"
                                  : "")
                              }
                              id="noOfVisitors"
                              />
                              <ErrorMessage
                                name="noOfVisitors"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="feedbackToClient">General impression</Label>
                              <SafeField
                             as="textarea"
                              name="feedbackToClient"
                              className={
                                "form-control" +
                                (errors.feedbackToClient && touched.feedbackToClient
                                  ? " is-invalid"
                                  : "")
                              }
                              id="feedbackToClient"
                              />
                              <ErrorMessage
                                name="feedbackToClient"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="reactionPropertyFeatures">Reactions on any property feature</Label>
                              <SafeField
                             as="textarea"
                              name="reactionPropertyFeatures"
                              className={
                                "form-control" +
                                (errors.reactionPropertyFeatures && touched.reactionPropertyFeatures
                                  ? " is-invalid"
                                  : "")
                              }
                              id="reactionPropertyFeatures"
                              />
                              <ErrorMessage
                                name="reactionPropertyFeatures"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="reactionWhatnotLiked">Reactions on  what not not liked</Label>
                              <SafeField
                              as="textarea"
                              name="reactionWhatnotLiked"
                              className={
                                "form-control" +
                                (errors.reactionWhatnotLiked && touched.reactionWhatnotLiked
                                  ? " is-invalid"
                                  : "")
                              }
                              id="reactionWhatnotLiked"
                              />
                              <ErrorMessage
                                name="reactionWhatnotLiked"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="commentsOnPricing">Comments on pricing</Label>
                              <SafeField
                            as="textarea"
                              name="commentsOnPricing"
                              className={
                                "form-control" +
                                (errors.commentsOnPricing && touched.commentsOnPricing
                                  ? " is-invalid"
                                  : "")
                              }
                              id="commentsOnPricing"
                              />
                              <ErrorMessage
                                name="commentsOnPricing"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="suggestionActionalbleInsights">Suggestions & Actionable Insights</Label>
                              <SafeField
                              as="textarea"
                              name="suggestionActionalbleInsights"
                              className={
                                "form-control" +
                                (errors.suggestionActionalbleInsights && touched.suggestionActionalbleInsights
                                  ? " is-invalid"
                                  : "")
                              }
                              id="suggestionActionalbleInsights"
                              />
                              <ErrorMessage
                                name="suggestionActionalbleInsights"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                            
                              <Label htmlFor="marketPositioning">Market Positioning</Label>
                              <SafeField
                              as="textarea"
                              name="marketPositioning"
                              className={
                                "form-control" +
                                (errors.marketPositioning && touched.marketPositioning
                                  ? " is-invalid"
                                  : "")
                              }
                              id="marketPositioning"
                              />
                              <ErrorMessage
                                name="marketPositioning"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        
                        <UpdateButton iconClass="bx bx-send">{this.props.t("Send")}</UpdateButton>{ " " }
                        
                        </Col>
                    </Row>

                
            </Form>
                  )}
			 </Formik>

                      </OffcanvasBody>
                    </Offcanvas>                  
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientSellerOpen.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  addClientSellerOphouse:PropTypes.func,
  onGetClientSellerListing:PropTypes.func,
  listings:PropTypes.array,
  onGetClientSellerOphouse:PropTypes.func,
  ophouses:PropTypes.array,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  onDeleteOpenhouse:PropTypes.func,
  onUpdateSellerOpenhouse:PropTypes.func,
  onUpdateClientOpenhouseFeedback:func,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
    listings:Clients.listings,
    ophouses:Clients.ophouses

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientSellerOphouse: (data) => dispatch(addClientSellerOphouse(data)),
  onGetClientSellerListing:(clientId) => dispatch(getClientSellerListing(clientId)),
  onGetClientSellerOphouse:(clientId) => dispatch(getClientSellerOphouse(clientId)),
  onDeleteOpenhouse: id => dispatch(deleteClientopenhouse(id)),
  onUpdateSellerOpenhouse:(data) => dispatch(updateClientOpenhouse(data)),
  onUpdateClientOpenhouseFeedback:(data) => dispatch(updateClientOpenhouseFeedback(data))
 
});
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ClientSellerOpen))
